import HomepageDispatcher from '../dispatcher/dispatcher'
import ActionTypes from '../constants/Action-Types'
import ajax from '../utils/ajax'
import {
  HTL_GEO_LOCATION_SEARCH_ENDPOINT
} from '../constants/API-Endpoints'
import ExecutionEnvironment from 'exenv'
const config = require('isomorphic-config')

const LOCATION_SEARCH_ENDPOINT = config.client.typeahead.location.general
const VP_LOCATION_SEARCH_ENDPOINT_ORIGIN = config.client.typeahead.location.packagesOrigin
const VP_LOCATION_SEARCH_ENDPOINT_DESTINATION = config.client.typeahead.location.packagesDestination
const RC_LOCATION_SEARCH_ENDPOINT = config.client.typeahead.location.cars

export default {
  query (options = {}) {
    const query = options.query
    const URL = this.getUrlFromQuery(options)

    ajax({ url: URL })
      .then(response => {
        if (response.data.searchItems) {
          HomepageDispatcher.dispatch({
            type: ActionTypes.LOCATION_SEARCH_FOUND,
            data: response.data.searchItems,
            query
          })
        }
      })
      .catch(() => {
        // TODO: Handle failure state
      })
  },

  // pure function to format parsed flight typeahead result's display
  parseFlightLocationDisplay (origRes, isUsingCityCodeDisplay = false) {
    const origItems = (origRes && origRes.searchItems) || []

    const searchItems = origItems.map(item => {
      const isStateValid = item.stateCode && item.stateCode !== '--'

      const stateOrCountry = isStateValid ? item.stateCode : item.country

      const finalCityName = item.cityName.length > 0 ? `${item.cityName}` : ''

      const finalStateOrProvince =
        stateOrCountry.length > 0 ? `, ${stateOrCountry}` : ''

      // "id" from origItem data seems to be unique 3-letter label between a city and an airport
      const finalThreeLetterLabel = item.id.length > 0 ? ` (${item.id}) ` : ''

      const itemName = `${finalCityName}${finalStateOrProvince}${finalThreeLetterLabel}`

      const displayNameAfterSelection = item.id || ''

      if (isUsingCityCodeDisplay) {
        return { ...item, itemName, displayNameAfterSelection }
      }

      return { ...item, itemName }
    })
    return { ...origRes, searchItems }
  },

  queryLocations (options = {}) {
    return new Promise((resolve, reject) => {
      const url = !options.query ? '' : this.getUrlFromQuery(options)

      if (!url) resolve([])

      ajax({ url: url })
        .then(response => {
          return options.isParsingFlightLocation
            ? this.parseFlightLocationDisplay(
              response.data,
              options.isUsingCityCodeDisplay
            )
            : response.data
        })
        .then(finalResponse => {
          if (finalResponse.searchItems) {
            resolve(finalResponse.searchItems)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  getPosition (options) {
    const CAN_USE_DOM = ExecutionEnvironment.canUseDOM
    if (CAN_USE_DOM) {
      return new Promise(function (resolve, reject) {
        if (!navigator || !navigator.geolocation) {
          const err = { UNSUPPORTED: 4 }
          reject(err)
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, options)
      })
    }
  },

  getCurrentLocation (options = { timeout: 5000 }) {
    return new Promise((resolve, reject) => {
      this.getPosition(options)
        .then(position => {
          const coords = position.coords
          const cityData = this.getCurrentCity(coords)
          resolve(cityData)
        })
        .catch(err => {
          console.error(err.message)
          reject(err)
        })
    })
  },

  getCurrentCity (args) {
    return new Promise((resolve, reject) => {
      let URL = ''
      if (args.latitude && args.longitude) {
        URL = `${HTL_GEO_LOCATION_SEARCH_ENDPOINT}${args.latitude}/${args.longitude}/5?version=1`
      }

      ajax({
        url: URL
      })
        .then(response => {
          if (response.data) {
            let cityData = {}
            const exactCityMatch = response.data.exactMatch && response.data.exactMatch.matchedCity
            const itemText =
              response.data.exactMatch && response.data.exactMatch.displayText
                ? response.data.exactMatch.displayText
                : ''
            cityData.itemName = itemText
            cityData.content = itemText
            cityData.type = 'GEO'
            cityData.lat =
              response.data.searchedLocation && response.data.searchedLocation.lat
                ? response.data.searchedLocation.lat
                : ''
            cityData.lon =
              response.data.searchedLocation && response.data.searchedLocation.lon
                ? response.data.searchedLocation.lon
                : ''
            cityData.cityID = exactCityMatch ? exactCityMatch.cityID : ''
            resolve(cityData)
          }
        })
        .catch(e => {
          console.error(e.message)
        })
    })
  },

  getUrlFromQuery (options) {
    const type = options.type
    const cities = options.cities || 0
    const airports = options.airports || 0
    const pois = options.pois || 0
    const hotels = options.hotels || 0
    const query = options.query
    const isRC = type === 'rentalcars'
    const isVP = type === 'vacation-packages'
    let endpoint

    if (isVP) {
      endpoint = options.setOrigin ? VP_LOCATION_SEARCH_ENDPOINT_ORIGIN : VP_LOCATION_SEARCH_ENDPOINT_DESTINATION
    } else {
      endpoint = `${LOCATION_SEARCH_ENDPOINT}${type}/`
    }

    const parseRCURL = () => `${RC_LOCATION_SEARCH_ENDPOINT}${query}?numCities=${cities}&numAirports=${airports}&numPOIs=${pois}`

    const parseDefaultURL = () =>
      `${endpoint}${query}/${cities}/${airports}/${hotels}/${pois}`

    let URL = isRC ? parseRCURL() : parseDefaultURL()

    return URL
  }
}
